<template>
  <!--表格设置弹窗-->
  <div>
    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="tableObj.title"
      :visible.sync="dialogVisible"
      width="55%"
      :destroy-on-close="true"
      :before-close="dialogClose"
      append-to-body
    >
      <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="changeCheckAll">
        {{ tableObj.checkAll }}
      </el-checkbox>
      <div style="margin: 15px 0" />
      <template v-for="(item, index) in columnList">
        <el-checkbox
          :key="index"
          v-model="item.isCheck"
          :label="item.label"
        />
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetTableColumn">{{ tableObj.restore }}</el-button>
        <el-button @click="dialogClose">{{ tableObj.cancel }}</el-button>
        <el-button type="primary" @click="dialogConfirm">{{ tableObj.ok }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'PurchaseElementTableSortable',
  props: {
    pageType: {
      type: String,
      require: true
    },
    sortableSetting: {
      type: Object,
      require: true
    },
    tableObj: {
      type: Object,
      default: () => {
        return {
          title: '设置',
          restore: '恢复默认',
          cancel: '取 消',
          ok: '确 认',
          checkAll: '全选'
        };
      }
    },
    title: {
      type: String,
      default: '设置',
    },
  },
  data() {
    return {
      dialogVisible: false,
      isIndeterminate: true,
      checkAll: true,
      columnList: [],
      columnList1: [
        {label: this.$t('BusinessPurchaseDetailPage.table.Australian'), isCheck: false, prop: 'auPurchasePrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Link'), isCheck: false, prop: 'linkUrl'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Consumption'), isCheck: false, prop: 'consumptionTax'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Platform'), isCheck: false, prop: 'platformPrice'},
        {label: this.$t('BusinessPurchaseComponentsPur.table.TaxCode'), isCheck: false, prop: 'taxCode'},
        {label: 'return+resend', isCheck: false, prop: 'refundResendPrice'},
        {label: this.$t('BusinessPurchaseApply.ebayPaypalPrice'), isCheck: false, prop: 'ebayPaypalPrice'},
        {label: this.$t('BusinessPurchaseApply.seaInlandFreight'), isCheck: false, prop: 'seaInlandFreight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Estimated'), isCheck: false, prop: 'estimatedProfit'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Expected'), isCheck: false, prop: 'estimatedProfitRate'},
        {label: this.$t('BusinessPurchaseComponentsPur.requiredDate'), isCheck: false, prop: 'requiredDate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Barcode'), isCheck: false, prop: 'barCode'},
        {label: this.$t('BusinessPurchaseDetailPage.table.brand'), isCheck: false, prop: 'brandName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Product1'), isCheck: false, prop: 'categoryName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Description'), isCheck: false, prop: 'skuName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.length'), isCheck: false, prop: 'length'},
        {label: this.$t('BusinessPurchaseDetailPage.table.width'), isCheck: false, prop: 'width'},
        {label: this.$t('BusinessPurchaseDetailPage.table.high'), isCheck: false, prop: 'height'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Weight'), isCheck: false, prop: 'weight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Volume'), isCheck: false, prop: 'volume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.per'), isCheck: false, prop: 'qty'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxLength'), isCheck: false, prop: 'cartonLength'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWidth'), isCheck: false, prop: 'cartonWidth'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxheight'), isCheck: false, prop: 'cartonHeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWeight'), isCheck: false, prop: 'cartonWeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxVolume'), isCheck: false, prop: 'cartonVolume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Buyer'), isCheck: false, prop: 'createdName'},
      ],
      columnList2: [
        {label: 'SKU', isCheck: false, prop: 'skuCode'},
        {label: this.$t('BusinessPurchaseApplyDetail.orderQty'), isCheck: false, prop: 'planQty'},
        {label: this.$t('BusinessPurchaseApply.cnPurchasePrice'), isCheck: false, prop: 'cnPurchasePrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Australian'), isCheck: false, prop: 'auPurchasePrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Selling'), isCheck: false, prop: 'price'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Link'), isCheck: false, prop: 'linkUrl'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Price'), isCheck: false, prop: 'linkMinPrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Express'), isCheck: false, prop: 'expressPrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Consumption'), isCheck: false, prop: 'consumptionTax'},
        {label: this.$t('BusinessPurchaseComponentsPur.table.TaxCode'), isCheck: false, prop: 'taxCode'},
        {label: this.$t('BusinessPurchaseComponentsPur.requiredDate'), isCheck: false, prop: 'requiredDate'},
        {label: this.$t('BusinessPurchaseApply.table.dailySales'), isCheck: false, prop: 'dailySales'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Estimated'), isCheck: false, prop: 'estimatedProfit'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Expected'), isCheck: false, prop: 'estimatedProfitRate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Actual'), isCheck: false, prop: 'actualProfitRate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.risk'), isCheck: false, prop: 'purchaseRiskLevel'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Barcode'), isCheck: false, prop: 'barCode'},
        {label: this.$t('BusinessPurchaseDetailPage.table.brand'), isCheck: false, prop: 'brandName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Product1'), isCheck: false, prop: 'categoryName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Description'), isCheck: false, prop: 'skuName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.length'), isCheck: false, prop: 'length'},
        {label: this.$t('BusinessPurchaseDetailPage.table.width'), isCheck: false, prop: 'width'},
        {label: this.$t('BusinessPurchaseDetailPage.table.high'), isCheck: false, prop: 'height'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Volume'), isCheck: false, prop: 'volume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Weight'), isCheck: false, prop: 'weight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxLength'), isCheck: false, prop: 'cartonLength'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWidth'), isCheck: false, prop: 'cartonWidth'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxheight'), isCheck: false, prop: 'cartonHeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxVolume'), isCheck: false, prop: 'cartonVolume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWeight'), isCheck: false, prop: 'cartonWeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.per'), isCheck: false, prop: 'qty'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Buyer'), isCheck: false, prop: 'createdName'},
      ],
      columnList3: [
        {label: 'SKU', isCheck: false, prop: 'skuCode'},
        {label: this.$t('BusinessPurchaseApplyDetail.orderQty'), isCheck: false, prop: 'planQty'},
        {label: this.$t('BusinessPurchaseApply.cnPurchasePrice'), isCheck: false, prop: 'cnPurchasePrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Australian'), isCheck: false, prop: 'auPurchasePrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Selling'), isCheck: false, prop: 'price'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Link'), isCheck: false, prop: 'linkUrl'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Price'), isCheck: false, prop: 'linkMinPrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Express'), isCheck: false, prop: 'expressPrice'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Consumption'), isCheck: false, prop: 'consumptionTax'},
        {label: 'refund & resend rate', isCheck: false, prop: 'resendRefundRate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Estimated'), isCheck: false, prop: 'estimatedProfit'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Expected'), isCheck: false, prop: 'estimatedProfitRate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Actual'), isCheck: false, prop: 'actualProfitRate'},
        {label: this.$t('BusinessPurchaseDetailPage.table.risk'), isCheck: false, prop: 'purchaseRiskLevel'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Barcode'), isCheck: false, prop: 'barCode'},
        {label: this.$t('BusinessPurchaseDetailPage.table.brand'), isCheck: false, prop: 'brandName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Product1'), isCheck: false, prop: 'categoryName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Description'), isCheck: false, prop: 'skuName'},
        {label: this.$t('BusinessPurchaseDetailPage.table.length'), isCheck: false, prop: 'length'},
        {label: this.$t('BusinessPurchaseDetailPage.table.width'), isCheck: false, prop: 'width'},
        {label: this.$t('BusinessPurchaseDetailPage.table.high'), isCheck: false, prop: 'height'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Volume'), isCheck: false, prop: 'volume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Weight'), isCheck: false, prop: 'weight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxLength'), isCheck: false, prop: 'cartonLength'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWidth'), isCheck: false, prop: 'cartonWidth'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxheight'), isCheck: false, prop: 'cartonHeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxVolume'), isCheck: false, prop: 'cartonVolume'},
        {label: this.$t('BusinessPurchaseDetailPage.table.boxWeight'), isCheck: false, prop: 'cartonWeight'},
        {label: this.$t('BusinessPurchaseDetailPage.table.per'), isCheck: false, prop: 'qty'},
        {label: this.$t('BusinessPurchaseDetailPage.table.Buyer'), isCheck: false, prop: 'createdName'},
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  methods: {
    // 打开
    show() {
      switch (this.pageType) {
        case 'PurchaseApplyAdd':
          this.columnList = this.columnList1;
          break;
        case 'PurchaseApplyDetail':
          this.columnList = this.columnList2;
          break;
        case 'PurchaseDetail':
          this.columnList = this.columnList3;
          break;
      }
      this.dialogVisible = true;
      this.columnList.forEach((item, index) => {
        if (this.sortableSetting[item.prop] !== undefined) {
          this.columnList[index].isCheck = this.sortableSetting[item.prop];
        }
      });
    },
    // 恢复默认
    resetTableColumn() {
      this.columnList.forEach(item => {
        item.isCheck = true;
      });
      this.dialogConfirm();
    },
    /* 关闭弹窗 */
    dialogClose() {
      this.dialogVisible = false;
    },
    // 确定保存
    dialogConfirm() {
      this.dialogVisible = false;
      this.columnList.forEach((item, index) => {
        if (this.sortableSetting[item.prop] !== undefined) {
          this.sortableSetting[item.prop] = this.columnList[index].isCheck;
        }
      });
      this.$emit('settingTableTitle', this.sortableSetting);
    },
    // 全选事件
    changeCheckAll(flag) {
      this.isIndeterminate = false;
      this.columnList.forEach(item => {
        item.isCheck = flag;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.top-right-btn {
  margin-bottom: 10px;
}

::v-deep .el-checkbox {
  margin-bottom: 10px;
}

::v-deep .el-checkbox__label {
  min-width: 150px;
}

@media (max-width: 550px) {
  .flex {
    display: block;
  }
}

/*** context-menu */
.context-menu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #eee;
    }
  }
}
</style>
